import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record as ImmutableRecord } from "immutable";
import ScopedFeatureFlag from "models/interfaces/scoped-feature-flag";

const defaultValues: ScopedFeatureFlag =
    RecordUtils.defaultValuesFactory<ScopedFeatureFlag>({
        name: "",
        value: false,
        key: "",
        description: "",
    });

export default class ScopedFeatureFlagRecord
    extends ImmutableRecord(defaultValues)
    implements ScopedFeatureFlag
{
    constructor(params?: ScopedFeatureFlag) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }

    public with(values: Partial<ScopedFeatureFlag>): ScopedFeatureFlagRecord {
        return this.merge(values) as ScopedFeatureFlagRecord;
    }
}
